import { Component, Input, OnInit } from '@angular/core';

@Component({
   selector: 'samweb-icon-with-colored-subicon',
   templateUrl: './icon-with-colored-subicon.component.html',
   styleUrls: ['./icon-with-colored-subicon.component.scss'],
})
export class IconWithColoredSubiconComponent implements OnInit {
   @Input()
   public primaryIcon;
   @Input()
   public secondaryIcon;
   constructor() {}

   ngOnInit(): void {}
}
